import { Form, Input, Select } from "antd"
import { toastError, toastSuccess } from "../../utils/toast"
import ButtonBack from "../../components/button/ButtonBack"
import { ITelegram, IUpdateTelegram } from "../../models/telegram.modal"
import ButtonSubmitBack from "../../components/button/ButtonSubmitBack"
import { useLoading } from "../../context/LoadingContext"
import { apiGetListCompanies, apiGetListPackages, apiUpdateTelegram } from "../../api"
import { useLocation, useNavigate } from "react-router-dom"
import { useCallback, useEffect, useState } from "react"
import { TELEGRAM } from "../../assets/constants/route_path"
import { ICompany } from "../../models/company.modal"
import { IPackage } from "../../models/package.modal"
import { formatCurrency } from "../../utils/string-utils"
import defaultParams from "../../assets/constants/default_params"
import { filterOptionByLabel } from "../../utils/filter-utils"

export default function TelegramUpdate() {
    const [companyOptions, setCompanyOptions] = useState<{ label: string, value: Number }[]>([])
    const [packageOptions, setPackageOptions] = useState<{ label: string, value: Number }[]>([])
    const [formUpdate] = Form.useForm()
    const { setIsLoading } = useLoading()
    const location = useLocation()
    const navigate = useNavigate()
    const telegram = location.state as ITelegram

    const fetchCompanies = useCallback(async () => {
        try {
            setIsLoading(true)
            const resPackages = await apiGetListCompanies({ limit: defaultParams.MAX_LIMIT })
            if (resPackages.data != null) {
                const options = resPackages.data.companies.map((item: ICompany) => ({
                    label: `${item.id} - ${item.name}`,
                    value: item.id
                }))
                setCompanyOptions(options)
            } else {
                setCompanyOptions([])
            }
            setIsLoading(false)
        } catch (error) {
            setIsLoading(false)
            console.log(error)
        }
    }, [setIsLoading])

    const fetchPackages = useCallback(async () => {
        try {
            setIsLoading(true)
            const resPackages = await apiGetListPackages({ limit: defaultParams.MAX_LIMIT })
            if (resPackages.data != null) {
                const options = resPackages.data.packages.map((item: IPackage) => ({
                    label: `${item.id} - ${item.name} - ${formatCurrency(Number(item.price))}/${item.numberDay} ngày`,
                    value: `${item.id}::${item.numberDay}`
                }))
                setPackageOptions(options)
            } else {
                setPackageOptions([])
            }
            setIsLoading(false)
        } catch (error) {
            setIsLoading(false)
            console.log(error)
        }
    }, [setIsLoading])

    useEffect(() => {
        fetchCompanies()
        fetchPackages()
    }, [fetchCompanies, fetchPackages])

    useEffect(() => {
        if (!telegram) {
            navigate(TELEGRAM)
        }
    }, [telegram, navigate])

    const handleUpdate = async (values: IUpdateTelegram) => {
        try {
            setIsLoading(true)
            values.id = Number(telegram.id)
            const [package_id, numberDay] = values.package_id?.toString()?.split('::')
            values.package_id = Number(package_id)
            values.prefix_packages = (Number(numberDay) / 30).toString()
            const resp = await apiUpdateTelegram(values)
            if (resp.status === 200) {
                toastSuccess('Cập nhật telegram thành công!')
                formUpdate.resetFields()
                navigate(TELEGRAM)
            } else {
                toastError('Có lỗi xảy ra!')
            }
            setIsLoading(false)
        } catch (error) {
            console.log(error);
            toastError('Có lỗi xảy ra!')
            setIsLoading(false)
        }
    }

    return (
        <div>
            <ButtonBack />
            <Form form={formUpdate} onFinish={handleUpdate} layout="vertical">
                <Form.Item name='room_id' label='Room ID' initialValue={telegram.room_id}
                    rules={[{ required: true, message: 'Vui lòng nhập room ID!' }]}>
                    <Input />
                </Form.Item>
                <Form.Item name='company_id' label='Công ty' initialValue={telegram.company?.id}
                    rules={[{ required: true, message: 'Vui lòng chọn công ty!' }]}>
                    <Select
                        style={{ width: '100%' }}
                        showSearch
                        placeholder="Chọn công ty"
                        options={companyOptions}
                        filterOption={filterOptionByLabel}
                    />
                </Form.Item>
                <Form.Item name='package_id' label='Gói cước' initialValue={`${telegram.package?.id}::${telegram.package?.numberDay}`}
                    rules={[{ required: true, message: 'Vui lòng chọn gói cước!' }]}>
                    <Select
                        style={{ width: '100%' }}
                        showSearch
                        placeholder="Chọn gói cước"
                        options={packageOptions}
                        filterOption={filterOptionByLabel}
                    />
                </Form.Item>
                <Form.Item name='webhook' label='Webhook' initialValue={telegram.webhook}>
                    <Input />
                </Form.Item>
                <ButtonSubmitBack />
            </Form>
        </div>
    )
}
